import { __extends } from "tslib";
import { deserializeAws_restXmlUploadPartCopyCommand, serializeAws_restXmlUploadPartCopyCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { getSsecPlugin } from "@aws-sdk/middleware-ssec";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UploadPartCopyCommand = /** @class */ (function (_super) {
    __extends(UploadPartCopyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UploadPartCopyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UploadPartCopyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getSsecPlugin(configuration));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UploadPartCopyCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlUploadPartCopyCommand(input, context);
    };
    UploadPartCopyCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlUploadPartCopyCommand(output, context);
    };
    return UploadPartCopyCommand;
}($Command));
export { UploadPartCopyCommand };
//# sourceMappingURL=UploadPartCopyCommand.js.map